<template>
    <v-dialog :value="true" max-width="520" :fullscreen="$vuetify.breakpoint.xsOnly" persistent scrollable>
        <v-card>
            <v-card-title class="d-block">
                <div class="text-h6">Liberar onda</div>
                <div class="body-2 grey--text text--darken-1">{{ empresas.length }} empresa(s) selecionada(s) · {{ resumoCenarios }}</div>
            </v-card-title>
            <v-divider/>

            <v-card-text class="pt-4">
                <v-combobox
                    v-model="form.onda"
                    :search-input.sync="ondaDigitada"
                    :items="ondas"
                    label="Nome da onda"
                    outlined
                    dense
                    hide-details="auto"
                    class="mb-4"
                />

                <div class="body-2 font-weight-medium mb-1">Modo</div>
                <v-radio-group v-model="form.modo" class="mt-0" hide-details>
                    <v-radio value="convite">
                        <template v-slot:label>
                            <span class="body-2"><b>Convite</b> · o lojista pode escolher "Lembrar depois"</span>
                        </template>
                    </v-radio>
                    <v-radio value="obrigatoria">
                        <template v-slot:label>
                            <span class="body-2"><b>Obrigatória</b> · sem "Lembrar depois"</span>
                        </template>
                    </v-radio>
                </v-radio-group>

                <v-row dense class="mt-3">
                    <v-col cols="12" sm="5">
                        <v-text-field
                            v-model.number="form.adiamentos_max"
                            type="number"
                            min="0"
                            label="Adiamentos permitidos"
                            outlined
                            dense
                            hide-details
                            :disabled="form.modo === 'obrigatoria'"
                        />
                    </v-col>
                    <v-col cols="12" sm="7">
                        <v-text-field
                            v-model="form.prazo_em"
                            type="datetime-local"
                            label="Prazo"
                            outlined
                            dense
                            persistent-hint
                            hint="Vazio usa o prazo geral. Preencha só para antecipar esta onda."
                        />
                    </v-col>
                </v-row>

                <v-simple-table dense class="mt-4 tabela-resumo">
                    <tbody>
                        <tr>
                            <td class="grey--text text--darken-1">Empresas</td>
                            <td>{{ empresas.length }}</td>
                        </tr>
                        <tr>
                            <td class="grey--text text--darken-1">PIX em 30 dias</td>
                            <td>{{ reais(volume) }}</td>
                        </tr>
                        <tr>
                            <td class="grey--text text--darken-1">Com conta de referência</td>
                            <td>{{ empresas.length - semReferencia }}</td>
                        </tr>
                        <tr>
                            <td class="grey--text text--darken-1">Sem conta de referência</td>
                            <td>{{ semReferencia }}<span v-if="semReferencia"> · só migram com liberação de outra conta</span></td>
                        </tr>
                        <tr v-if="naoCandidatas">
                            <td class="grey--text text--darken-1">Já liberadas ou concluídas</td>
                            <td>{{ naoCandidatas }} · ficam como estão</td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <v-alert dense text type="info" class="mt-4 mb-0 body-2">
                    A tela aparece no próximo login dos administradores dessas empresas.
                </v-alert>
            </v-card-text>

            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn text @click="$emit('close')">Cancelar</v-btn>
                <v-btn color="primary" :loading="enviando" @click="liberar">
                    Liberar {{ empresas.length - naoCandidatas }} empresa(s)
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { reais } from './situacoes';

export default {
    name: 'LiberarOndaDialog',

    props: {
        empresas: { type: Array, required: true },
        ondas: { type: Array, default: () => [] },
    },

    data: () => ({
        enviando: false,
        // O combobox só confirma o texto no blur/Enter: o que está digitado vale mesmo sem confirmar.
        ondaDigitada: '',
        form: { onda: '', modo: 'convite', adiamentos_max: 3, prazo_em: '' },
    }),

    computed: {
        resumoCenarios() {
            const pj = this.empresas.filter(e => e.cenario === 'reconexao_pj').length;
            const legado = this.empresas.length - pj;

            return [pj && `${pj} PF → PJ`, legado && `${legado} chave de acesso`].filter(Boolean).join(' · ');
        },

        volume() {
            return this.empresas.reduce((soma, e) => soma + (e.volume_pix_30d_antes || 0), 0);
        },

        semReferencia() {
            return this.empresas.filter(e => e.situacao === 'sem_referencia' || (!e.titular && !e.outra_conta_liberada_em)).length;
        },

        naoCandidatas() {
            return this.empresas.filter(e => !['candidata', 'desfeita'].includes(e.status)).length;
        },
    },

    methods: {
        reais,

        async liberar() {
            this.enviando = true;

            try {
                const { data } = await this.$http.post('mercadopago-migracao/liberar', {
                    empresas: this.empresas.map(e => e.empresa_id),
                    onda: (this.ondaDigitada || this.form.onda || '').trim() || null,
                    modo: this.form.modo,
                    adiamentos_max: this.form.adiamentos_max,
                    prazo_em: this.form.prazo_em ? this.form.prazo_em.replace('T', ' ') : null,
                });

                this.notify(data.msg, data.type === 'success' ? 'success' : 'warning');
                data.type === 'success' && this.$emit('liberou');
            } catch (e) {
                this.notify('Verifique sua conexão com a internet', 'warning');
            } finally {
                this.enviando = false;
            }
        },
    },
};
</script>

<style scoped>
.tabela-resumo {
    border: 1px solid #e1e6ed;
}
</style>
